/* Sockiety: product-row arrows + quick add into Dawn's cart drawer */
(function () {
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-sk-scroll]');
    if (arrow) {
      var track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (track) {
        var dir = arrow.getAttribute('data-sk-scroll') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      return;
    }

    var add = event.target.closest('[data-sk-add]');
    if (!add || add.disabled) return;
    event.preventDefault();
    add.classList.add('is-loading');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(add.getAttribute('data-sk-add')), quantity: 1 }] };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          window.alert(state.description || state.message || 'Could not add this item.');
          return;
        }
        var details = add.closest('details');
        if (details) details.removeAttribute('open');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = root + 'cart'; })
      .finally(function () { add.classList.remove('is-loading'); });
  });
})();
